import { Datos } from './Context/Contexto';
import { Mostr } from './Context/Mostrando';
import { ProviderTokens } from './Context/ProviderToken';
import { NotiContextoLlamado } from './Context/Notificaciones_Context';
import { GuiaBusquedaGeneral } from './Context/BusquedaGuiaContext';
import { MensajeGeneral } from './Context/MensajeContext';
import { MensajeActualizacionCon } from './Context/MensajeContextActualizacion';
import AppRouter from './Componentes/Router/AppRouter';
import ReactGA from 'react-ga4';

function App() {
  //Produccion
  ReactGA.initialize('G-H0HFFR5396'); 

  //desarrollo
  //ReactGA.initialize('G-DYG0E4C90R');
  return (
    <>
    
      <ProviderTokens>
        <Datos>
          <NotiContextoLlamado>
            <Mostr>
              <GuiaBusquedaGeneral>
                <MensajeGeneral>
                  <MensajeActualizacionCon>
                    <AppRouter/>
                  </MensajeActualizacionCon>
                </MensajeGeneral>
              </GuiaBusquedaGeneral>
            </Mostr>
          </NotiContextoLlamado>
        </Datos>
      </ProviderTokens>
      {/* <PagoWeb></PagoWeb> */}
    </>
  );
}

export default App;
